import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  method: "post",
  action: "/pdf/test-result"
}
const _hoisted_2 = ["defaultValue"]
const _hoisted_3 = ["defaultValue"]
const _hoisted_4 = ["defaultValue"]
const _hoisted_5 = ["defaultValue"]
const _hoisted_6 = ["defaultValue"]
const _hoisted_7 = ["defaultValue"]
const _hoisted_8 = ["defaultValue"]
const _hoisted_9 = ["defaultValue"]
const _hoisted_10 = ["defaultValue"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  className: "sf-btn-primary"
}, "Print", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", _hoisted_1, [
      _createElementVNode("input", {
        type: "hidden",
        name: "_csrf",
        defaultValue: _ctx.csrfToken
      }, null, 8, _hoisted_2),
      _createElementVNode("input", {
        type: "hidden",
        name: "test_result_id",
        defaultValue: _ctx.testResultId
      }, null, 8, _hoisted_3),
      _createElementVNode("input", {
        type: "hidden",
        name: "word_category_id",
        defaultValue: _ctx.wordCategoryId
      }, null, 8, _hoisted_4),
      _createElementVNode("input", {
        type: "hidden",
        name: "math_test_id",
        defaultValue: _ctx.mathsTestId
      }, null, 8, _hoisted_5),
      _createElementVNode("input", {
        type: "hidden",
        name: "math_level_id",
        defaultValue: _ctx.mathsLevelId
      }, null, 8, _hoisted_6),
      _createElementVNode("input", {
        type: "hidden",
        name: "score",
        defaultValue: JSON.stringify(_ctx.score)
      }, null, 8, _hoisted_7),
      _createElementVNode("input", {
        type: "hidden",
        name: "student_name",
        defaultValue: _ctx.playerName
      }, null, 8, _hoisted_8),
      _createElementVNode("input", {
        type: "hidden",
        name: "test_time",
        defaultValue: _ctx.displayDate
      }, null, 8, _hoisted_9),
      _createElementVNode("input", {
        type: "hidden",
        name: "time_offset",
        defaultValue: _ctx.timeOffset
      }, null, 8, _hoisted_10),
      _hoisted_11
    ])
  ]))
}